import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import AttachmentMenuEntrySource from '../types/AttachmentMenuEntrySource';
import { AttachmentMultiMenuMap } from '../types/AttachmentMultiMenuMap';

export function getAttachmentMenuItemsBasedOnClickHandler(
    attachmentMenuClickHandler: AttachmentMultiMenuMap<() => void>
): IContextualMenuItem[] {
    const menuItems: IContextualMenuItem[] = [];
    Object.keys(attachmentMultiMenuEntry).forEach(function (key) {
        if (attachmentMenuClickHandler[key]) {
            const attachmentMenuEntry = attachmentMultiMenuEntry[key];
            const aria = attachmentMenuEntry.ariaLabel?.();
            const menuItem: IContextualMenuItem = {
                name: attachmentMenuEntry.text(),
                key: attachmentMenuEntry.text(),
                onClick: () => {
                    attachmentMenuEntry.logUsage(AttachmentMenuEntrySource.CommandingBar);
                    attachmentMenuClickHandler[key]();
                },
                iconProps: attachmentMenuEntry.iconProps,
                ariaLabel: aria,
                title: aria,
            };
            menuItems.push(menuItem);
        }
    });
    return menuItems;
}
